module.exports = __webpack_public_path__ + "img/result-detail-communcation-icon01.cc675ea1.svg";